import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import GoalButton from "layouts/goals/components/GoalButton";

function DeleteAdminUserModal({ open, onClose, onConfirm, userName, isSubmitting }) {
  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle>Delete user?</DialogTitle>
      <DialogContent>
        <SuiTypography variant="button" color="text" display="block">
          Are you sure you want to delete &quot;{userName}&quot;? They will no longer be able to
          sign in and will be removed from this list.
        </SuiTypography>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton
          variant="danger"
          icon="delete_outline"
          loading={isSubmitting}
          onClick={onConfirm}
        >
          Delete
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteAdminUserModal;
